export function subscriptionTimeZone(timeZone?: string): string {
  if (timeZone) {
    try {
      new Intl.DateTimeFormat("en-GB", { timeZone });
      return timeZone;
    } catch {
      // Missing or invalid site zones use UTC for consistent calendar boundaries.
    }
  }
  return "UTC";
}

export function subscriptionDaysRemaining(date: string, now: Date, timeZone?: string): number {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: subscriptionTimeZone(timeZone),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes) => Number(parts.find((p) => p.type === type)?.value);
  const today = new Date(0);
  today.setUTCFullYear(part("year"), part("month") - 1, part("day"));
  // Calendar dates are compared on a UTC axis, avoiding 23/25-hour DST days.
  return Math.round((Date.parse(`${date}T00:00:00Z`) - today.getTime()) / 86400000);
}

export function formatSubscriptionDate(date: string): string {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${date}T00:00:00Z`));
}

export function compareSubscriptionDates(
  a: string | undefined,
  b: string | undefined,
  direction: "asc" | "desc" | null | undefined
): number {
  if (!a || !b) {
    // MUI v6 reverses comparators for descending sorts, so counter-reverse only undated rows.
    return (a ? -1 : b ? 1 : 0) * (direction === "desc" ? -1 : 1);
  }
  return a.localeCompare(b);
}
